import React from "react";
import styled from "styled-components";
import Img from "gatsby-image";
import { useStaticQuery, graphql } from "gatsby";
import { getImages } from "utils/images";

const CircleIcon = styled(Img)`
  border-radius: 50%;
  top: -40px;
  left: -40px;
  box-shadow: 0px 30px 30px -30px rgba(0, 0, 0, 0.3);
`;
const Wrap = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
`;

const EnvironmentIcon = ({ index, count = 5, primary }) => {
  const data = useStaticQuery(graphql`
    query {
      icons: allFile(
        filter: {
          extension: { regex: "/(jpg)|(png)|(jpeg)/" }
          relativeDirectory: { eq: "envs" }
        }
      ) {
        edges {
          node {
            base
            childImageSharp {
              fixed(quality: 100, width: 100) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      }
    }
  `);

  const images = getImages(data);

  if (primary) {
    return (
      <Wrap>
        <CircleIcon {...images.getFile("spectro_logo", "icons")} />
      </Wrap>
    );
  }

  const startDeg = 90 - (360 / count) * index;
  const targetDeg = startDeg - 360 / count;

  return (
    <Wrap>
      <CircleIcon
        {...images.getFile(`${index + 1}`, "icons")}
        style={{
          position: "absolute",
          width: "100px",
          height: "100px",
          transform: `rotate(${-targetDeg}deg) translate(180px, 0px) rotate(${targetDeg}deg)`,
        }}
      />
    </Wrap>
  );
};

export default EnvironmentIcon;
